module.exports = __webpack_public_path__ + "files/2fb97a7525fb4919e7fd2567232e2138.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-5.png
// module id = 531
// module chunks = 76